import * as TypeGraphQL from "type-graphql";
export var SignalDecisionType;
(function (SignalDecisionType) {
    SignalDecisionType["ACCEPT"] = "ACCEPT";
    SignalDecisionType["REJECT"] = "REJECT";
    SignalDecisionType["DEFER"] = "DEFER";
    SignalDecisionType["MODIFY"] = "MODIFY";
})(SignalDecisionType || (SignalDecisionType = {}));
TypeGraphQL.registerEnumType(SignalDecisionType, {
    name: "SignalDecisionType",
    description: undefined,
});
//# sourceMappingURL=SignalDecisionType.js.map